/**
 * Auth hook providing access to the auth store with convenience helpers.
 */

import { useAuthStore } from '@/store/authStore';
import type { Role } from '@/types/auth';

/** Access auth state and actions from any component. */
export function useAuth() {
  const store = useAuthStore();
  return {
    user: store.user,
    isLoading: store.isLoading,
    isAuthenticated: store.isAuthenticated,
    mfaChallenge: store.mfaChallenge,
    login: store.login,
    verifyMfa: store.verifyMfa,
    useRecoveryCode: store.useRecoveryCode,
    logout: store.logout,
    loadUser: store.loadUser,
    updateUser: store.updateUser,
    hasRole: store.hasRole,
    isPlatformAdmin: store.hasRole('platform_admin'),
    isCustomerAdmin: store.hasRole('platform_admin', 'customer_admin'),
    canManageFindings: store.hasRole('platform_admin', 'customer_admin', 'remediation_lead'),
  };
}

/** Hook that returns true if the current user has at least one of the given roles. */
export function useRequireRole(...roles: Role[]): boolean {
  return useAuthStore((s) => s.user !== null && roles.includes(s.user.role));
}
